import * as React from 'react';
import Box from '@mui/material/Box';
import { useMatomo } from '@datapunt/matomo-tracker-react'
import { useLocation } from 'react-router-dom';

import WelcheFührug from './sub/WelcheFührug'
import Photogallery from './sub/Photogallery';

import mainImage from '../../images/tour/Balkonversuch-gesamt.JPG';

export default function Führungen() {

  const { trackPageView } = useMatomo()
    const location = useLocation();
    
  // Track page view
  React.useEffect(() => {
    trackPageView({
      documentTitle: 'Führungen', // optional
      href: 'https://naturimgarten.laimburg.it' + location.pathname, // optional
      customDimensions: [
        {
          id: 1,
          value: 'loggedIn',
        },
      ], // optional
    })
  }, [trackPageView])

  return (
    
    <Box>

      <Box className='mainimagebox' >
        <img className='mainimage'
          src={mainImage}
          alt="placeholder"
          width='100%'
        />
      </Box>

      <WelcheFührug />

      <Photogallery/>
      
      {/* 
        <Box>
          <PicturesFühr />
        </Box>
      */}

    </Box>
  );
}
